export enum ValidDestinationCategory {
  EMAIL = 'Email',
  ADS = 'Ads',
  SMS = 'SMS',
  LIVECHAT = 'Livechat',
  PUSH = 'Push',
  SFTP = 'SFTP',
  WAREHOUSE = 'Datawarehouse',
}

export enum DestinationConfigTabs {
  CONFIGURE = 'configure',
  ACTIVITY = 'activity',
}
